import { CartSlices } from "./slices";
import axios from "axios";

const { actions } = CartSlices;

export const add = (payload) => (dispatch) => {
  dispatch(actions.add(payload));
};

export const update = (id, quantity) => (dispatch) => {
  dispatch(actions.update({ id, quantity }));
};

export const remove = (id) => (dispatch) => {
  dispatch(actions.delete({ id }));
};

export const clear = () => (dispatch) => {
  dispatch(actions.clear());
};

export const applyDiscount = (payload) => (dispatch) => {
  dispatch(actions.applyDiscount(payload));
};

export const removeDiscount = () => (dispatch) => {
  dispatch(actions.removeDiscount());
};

export const syncCart = (localCart) => async (dispatch) => {
  try {
    const response = await axios.post("/cart/sync", { cart: localCart });
    const updatedCart = response.data.cart;

    const validCartMap = {};
    updatedCart.forEach((item) => {
      validCartMap[item.product_id] = item.quantity;
    });

    // Update quantities for valid items
    Object.entries(validCartMap).forEach(([id, quantity]) => {
      dispatch(update(Number(id), quantity));
    });

    // Remove items that are not in the valid cart OR have 0 quantity
    localCart.forEach((item) => {
      const productId = item.product_id || item.id;
      const validQty = validCartMap[productId];

      if (!validQty || validQty === 0) {
        dispatch(remove(productId));
      }
    });
  } catch (error) {
    console.error("Cart sync failed:", error);
  }
};
